package kz.dentalcrm.app.expectations

actual val usePredictiveBackGesture: Boolean = true
